export const englishMessages = {
    'app.title': 'Face Lab — Face analysis in your browser',
    'app.description':
        'Detect, analyze, and match faces without sending images away from your device.',
    'language.label': 'Language',
    'language.auto': 'Automatic',
    'language.en': 'English',
    'language.tr': 'Türkçe',
    'theme.label': 'Color theme',
    'theme.system': 'System',
    'theme.light': 'Light',
    'theme.dark': 'Dark',
    'theme.next': 'Switch to %{theme}',
    'header.home': 'Face Lab home page',
    'header.privacy': 'Your media never leaves this device',
    'header.reset': 'Reset',
    'footer.engine': 'face-api.js · TensorFlow.js',
    'footer.site': 'About Face Lab',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms of Use',
    'footer.parentSite': 'sunuyoruz.biz',
    'status.initial': 'Add media to get started.',
    'status.analysisFailed': 'Analysis could not be completed.',
    'status.targetsAnalyzed': '%{count} faces analyzed in the search area.',
    'status.addTarget': 'Add the search area media.',
    'status.addReference': 'Add reference media for matching.',
    'status.ready': 'Ready to run the analysis.',
    'status.preparing': 'Preparing the analysis engine…',
    'status.complete': 'Analysis complete.',
    'status.modelsPreparing': 'Preparing %{count} models…',
    'status.referenceFaces': 'Extracting reference faces…',
    'status.targetFaces': 'Analyzing faces in the search area…',
    'error.unexpected': 'An unexpected analysis error occurred.',
    'error.modelLoad': 'Model files could not be loaded. Check the model URL and network access.',
    'error.unknownModel': 'Unknown model: %{model}',
    'error.canvas': 'The media preprocessing canvas could not be created.',
    'error.referenceRequired': 'Reference media is required for matching.',
    'error.referenceNotFound': 'No face was found in the reference media.',
    'error.invalidScaleSteps': 'Custom scale steps must contain numbers greater than zero.',
    'error.invalidFile': 'Choose an image or video file.',
    'error.fileRead': 'The file could not be read.',
    'error.invalidUrl': 'The address is not valid.',
    'error.protocol': 'Only HTTP or HTTPS addresses can be used.',
    'error.imageLoad': 'The media could not be loaded. Check the URL and CORS permissions.',
    'error.videoLoad':
        'The video could not be loaded. Check its format, URL, and CORS permissions.',
    'media.referenceTitle': 'REFERENCE',
    'media.targetTitle': 'SEARCH AREA',
    'media.notRequired': 'Not required',
    'media.waiting': 'Waiting',
    'media.referenceArea': 'Reference media upload area',
    'media.targetArea': 'Media upload area for the search area',
    'media.addReference': 'Add reference faces',
    'media.addTarget': 'Add search area media',
    'media.referenceDisabled': 'Reference media is not used when face matching is off.',
    'media.drop': 'Drop an image or video file here',
    'media.chooseFile': 'Choose file',
    'media.addUrl': 'Add URL',
    'media.urlType': 'URL media type',
    'media.image': 'Image',
    'media.video': 'Video',
    'media.urlAddress': 'Media URL address',
    'media.urlPlaceholder': 'https://example.com/media.jpg',
    'media.load': 'Load',
    'media.cors': 'The remote server must allow browser CORS access.',
    'media.localFile': 'Local file',
    'media.remoteUrl': 'Remote URL',
    'media.remove': 'Remove media',
    'media.removeButton': 'Remove',
    'media.layers': 'Layers',
    'media.showLayers': 'Show drawn layers',
    'media.hideLayers': 'Hide drawn layers',
    'media.unknownFaces': 'Unknown faces',
    'media.showUnknownFaces': 'Show unknown faces',
    'media.hideUnknownFaces': 'Hide unknown faces',
    'media.referenceAlt': 'Reference media',
    'media.targetAlt': 'Search area media',
    'media.frameNote': 'Analysis runs on the frame where the video is paused.',
    'settings.eyebrow': 'RUN SETTINGS',
    'settings.title': 'Analysis pipeline',
    'settings.tabs': 'Setting groups',
    'settings.tab.analysis': 'Analysis',
    'settings.tab.detector': 'Detector',
    'settings.tab.drawing': 'Drawing',
    'settings.tab.models': 'Models',
    'settings.section.detection': 'Detection',
    'settings.section.features': 'Features',
    'settings.section.matching': 'Matching and alignment',
    'settings.section.tinyDetectors': 'Tiny Face Detector / Tiny YOLOv2',
    'settings.section.layers': 'Layers',
    'settings.section.colors': 'Colors',
    'settings.section.sizes': 'Sizes and thresholds',
    'settings.section.catalog': 'Model catalog',
    'settings.detector': 'Face detection model',
    'settings.landmarkModel': 'Face landmark model',
    'settings.weightsMissing': 'weights unavailable',
    'settings.landmarkFull': '68 points · full',
    'settings.landmarkTiny': '68 points · tiny',
    'settings.landmarkNotRequired': 'The selected features do not require a landmark model.',
    'settings.outputs': 'Outputs',
    'settings.feature.matching.label': 'Face matching',
    'settings.feature.matching.description':
        'Compares every reference face with every face in the search area.',
    'settings.feature.landmarks.label': '68 face landmarks',
    'settings.feature.landmarks.description':
        'Extracts the jaw, eyebrows, eyes, nose, and mouth contours.',
    'settings.feature.expressions.label': 'Expression analysis',
    'settings.feature.expressions.description':
        'Neutral, happy, sad, angry, fearful, disgusted, and surprised.',
    'settings.feature.ageAndGender.label': 'Age and gender',
    'settings.feature.ageAndGender.description':
        "Shows estimated age and the model's binary gender classification.",
    'settings.align': 'Align faces',
    'settings.alignDescription':
        'Improves expression, age, and gender analysis stability. Required for matching.',
    'settings.distanceThreshold': 'Match distance threshold',
    'settings.maxDimension': 'Maximum analysis dimension',
    'settings.fast': 'fast',
    'settings.recommended': 'recommended',
    'settings.originalSize': 'Original size',
    'settings.dimensionHelp':
        'Large media is proportionally downscaled before analysis; results are mapped back to original coordinates.',
    'settings.detectorInactive': 'These settings apply when this detector is selected.',
    'settings.minimumConfidence': 'Minimum confidence',
    'settings.maximumResults': 'Maximum results',
    'settings.inputSize': 'Input size',
    'settings.scoreThreshold': 'Score threshold',
    'settings.minimumFaceSize': 'Minimum face size',
    'settings.scaleFactor': 'Scale factor',
    'settings.maximumScales': 'Maximum scales',
    'settings.stageThreshold': 'Stage %{stage} score threshold',
    'settings.customScaleSteps': 'Custom scale steps',
    'settings.commaSeparatedSteps': 'Comma-separated steps',
    'settings.overlay.reference': 'Reference layers',
    'settings.overlay.haystack': 'Search area layers',
    'settings.drawingHelp':
        'Drawing changes apply to the current result without rerunning the analysis.',
    'settings.unknownFaces': 'Unknown faces',
    'settings.unknownFacesDescription':
        'Draws faces that did not match any reference. Requires face matching.',
    'settings.boxes': 'Bounding boxes',
    'settings.scores': 'Detection scores',
    'settings.labels': 'Labels and analysis values',
    'settings.landmarkLines': 'Landmark lines',
    'settings.landmarkPoints': 'Landmark points',
    'settings.color.box': 'Box',
    'settings.color.match': 'Match',
    'settings.color.unknown': 'Unknown',
    'settings.color.landmarkLine': 'Landmark line',
    'settings.color.landmarkPoint': 'Landmark point',
    'settings.lineWidth': 'Line width',
    'settings.pointSize': 'Point size',
    'settings.fontSize': 'Label font size',
    'settings.expressionProbability': 'Minimum expression probability',
    'settings.modelSource': 'Model source',
    'settings.modelRootUrl': 'Model root URL',
    'settings.modelSourceHelp': 'Manifest and shard files must be in the same directory.',
    'settings.modelReady': 'Ready',
    'settings.modelUnavailable': 'Official weights unavailable',
    'settings.runRunning': 'Analysis running…',
    'settings.run': 'Run analysis',
    'model.tinyFaceDetector': 'Tiny Face Detector',
    'model.ssdMobilenetv1': 'SSD MobileNet V1',
    'model.mtcnn': 'MTCNN',
    'model.tinyYolov2': 'Tiny YOLOv2',
    'model.faceLandmark68Net': '68-point face landmarks',
    'model.faceLandmark68TinyNet': 'Tiny 68-point face landmarks',
    'model.faceRecognitionNet': 'Face recognition network',
    'model.faceExpressionNet': 'Face expression network',
    'model.ageGenderNet': 'Age and gender network',
    'results.eyebrow': 'ANALYSIS COMPLETE',
    'results.title': 'Faces found',
    'results.matches': '%{count} matches',
    'results.targets': '%{count} search area faces',
    'results.seconds': '%{seconds} sec',
    'results.references': 'References',
    'results.reference': 'Reference',
    'results.referenceNumber': 'Person %{number}',
    'results.referenceLabel': 'Label for reference %{number}',
    'results.targetFaces': 'Search area faces',
    'results.faceNumber': 'Face %{number}',
    'results.noMatch': 'Unknown',
    'results.noFaces':
        'No face was found in the search area. Try changing the detection model or threshold settings.',
    'results.metric.detection': 'detection',
    'results.metric.expression': 'expression',
    'results.metric.age': 'age',
    'results.metric.gender': 'gender',
    'results.metric.distance': 'distance',
    'results.gender.female': 'Female',
    'results.gender.male': 'Male',
    'results.expression.neutral': 'Neutral',
    'results.expression.happy': 'Happy',
    'results.expression.sad': 'Sad',
    'results.expression.angry': 'Angry',
    'results.expression.fearful': 'Fearful',
    'results.expression.disgusted': 'Disgusted',
    'results.expression.surprised': 'Surprised',
    'webmcp.title': 'Prepare face analysis',
    'webmcp.description':
        'Prepares the face detection model, matching choice, and media URLs in the visible Face Lab interface. It does not run the analysis.',
    'webmcp.error.kind': 'Media type must be image or video.',
    'webmcp.error.haystack': 'haystackUrl is a required text field.',
    'webmcp.error.detector': 'Invalid face detection model.',
    'webmcp.error.reference': 'referenceUrl is required when matching is enabled.',
} as const;

export type MessageKey = keyof typeof englishMessages;

export const turkishMessages: Readonly<Record<MessageKey, string>> = {
    'app.title': 'Face Lab — Tarayıcıda yüz analizi',
    'app.description':
        'Görüntüleri cihazınızdan çıkarmadan yüz tespiti, analizi ve eşleştirme yapın.',
    'language.label': 'Dil',
    'language.auto': 'Otomatik',
    'language.en': 'English',
    'language.tr': 'Türkçe',
    'theme.label': 'Renk teması',
    'theme.system': 'Sistem',
    'theme.light': 'Açık',
    'theme.dark': 'Koyu',
    'theme.next': '%{theme} temasına geç',
    'header.home': 'Face Lab ana sayfası',
    'header.privacy': 'Medyanız bu cihazdan çıkmaz',
    'header.reset': 'Sıfırla',
    'footer.engine': 'face-api.js · TensorFlow.js',
    'footer.site': 'Face Lab hakkında',
    'footer.privacy': 'Gizlilik Politikası',
    'footer.terms': 'Kullanım Şartları',
    'footer.parentSite': 'sunuyoruz.biz',
    'status.initial': 'Başlamak için medya ekleyin.',
    'status.analysisFailed': 'Analiz tamamlanamadı.',
    'status.targetsAnalyzed': 'Arama alanında %{count} yüz incelendi.',
    'status.addTarget': 'Arama alanı medyasını ekleyin.',
    'status.addReference': 'Eşleştirme için referans medyasını ekleyin.',
    'status.ready': 'Analiz çalışmaya hazır.',
    'status.preparing': 'Analiz motoru hazırlanıyor…',
    'status.complete': 'Analiz tamamlandı.',
    'status.modelsPreparing': '%{count} model hazırlanıyor…',
    'status.referenceFaces': 'Referans yüzleri çıkarılıyor…',
    'status.targetFaces': 'Arama alanındaki yüzler inceleniyor…',
    'error.unexpected': 'Beklenmeyen bir analiz hatası oluştu.',
    'error.modelLoad': 'Model dosyaları yüklenemedi. Model URL’sini ve ağ erişimini kontrol edin.',
    'error.unknownModel': 'Bilinmeyen model: %{model}',
    'error.canvas': 'Medya ön işleme tuvali oluşturulamadı.',
    'error.referenceRequired': 'Eşleştirme için referans medyası gerekli.',
    'error.referenceNotFound': 'Referans medyasında yüz bulunamadı.',
    'error.invalidScaleSteps': 'Özel ölçek adımları sıfırdan büyük sayılardan oluşmalıdır.',
    'error.invalidFile': 'Lütfen bir görsel veya video dosyası seçin.',
    'error.fileRead': 'Dosya okunamadı.',
    'error.invalidUrl': 'Adres geçerli değil.',
    'error.protocol': 'Yalnızca HTTP veya HTTPS adresleri kullanılabilir.',
    'error.imageLoad': 'Medya yüklenemedi. URL ve CORS izinlerini kontrol edin.',
    'error.videoLoad': 'Video yüklenemedi. Biçimi, URL’yi ve CORS izinlerini kontrol edin.',
    'media.referenceTitle': 'REFERANS',
    'media.targetTitle': 'ARAMA ALANI',
    'media.notRequired': 'Gerekmiyor',
    'media.waiting': 'Bekleniyor',
    'media.referenceArea': 'Referans medyası yükleme alanı',
    'media.targetArea': 'Arama alanı için medya yükleme alanı',
    'media.addReference': 'Referans yüzleri ekleyin',
    'media.addTarget': 'Arama alanı medyasını ekleyin',
    'media.referenceDisabled': 'Yüz eşleştirme kapalıyken referans medyası kullanılmaz.',
    'media.drop': 'Görsel veya video dosyasını buraya bırakın',
    'media.chooseFile': 'Dosya seç',
    'media.addUrl': 'URL ekle',
    'media.urlType': 'URL medya türü',
    'media.image': 'Görsel',
    'media.video': 'Video',
    'media.urlAddress': 'Medya URL adresi',
    'media.urlPlaceholder': 'https://ornek.com/medya.jpg',
    'media.load': 'Yükle',
    'media.cors': 'Uzak sunucu tarayıcı CORS erişimine izin vermelidir.',
    'media.localFile': 'Yerel dosya',
    'media.remoteUrl': 'Uzak URL',
    'media.remove': 'Medyayı kaldır',
    'media.removeButton': 'Kaldır',
    'media.layers': 'Katmanlar',
    'media.showLayers': 'Çizilen katmanları göster',
    'media.hideLayers': 'Çizilen katmanları gizle',
    'media.unknownFaces': 'Tanınmayan yüzler',
    'media.showUnknownFaces': 'Tanınmayan yüzleri göster',
    'media.hideUnknownFaces': 'Tanınmayan yüzleri gizle',
    'media.referenceAlt': 'Referans medyası',
    'media.targetAlt': 'Arama alanı medyası',
    'media.frameNote': 'Analiz, videonun duraklatıldığı karede çalışır.',
    'settings.eyebrow': 'ÇALIŞMA AYARLARI',
    'settings.title': 'Analiz zinciri',
    'settings.tabs': 'Ayar grupları',
    'settings.tab.analysis': 'Analiz',
    'settings.tab.detector': 'Dedektör',
    'settings.tab.drawing': 'Çizim',
    'settings.tab.models': 'Modeller',
    'settings.section.detection': 'Tespit',
    'settings.section.features': 'Özellikler',
    'settings.section.matching': 'Eşleştirme ve hizalama',
    'settings.section.tinyDetectors': 'Tiny Face Detector / Tiny YOLOv2',
    'settings.section.layers': 'Katmanlar',
    'settings.section.colors': 'Renkler',
    'settings.section.sizes': 'Boyutlar ve eşikler',
    'settings.section.catalog': 'Model kataloğu',
    'settings.detector': 'Yüz tespit modeli',
    'settings.landmarkModel': 'Yüz işareti modeli',
    'settings.weightsMissing': 'ağırlık yok',
    'settings.landmarkFull': '68 nokta · tam',
    'settings.landmarkTiny': '68 nokta · tiny',
    'settings.landmarkNotRequired': 'Seçili özellikler yüz işareti modeli gerektirmiyor.',
    'settings.outputs': 'Çıktılar',
    'settings.feature.matching.label': 'Yüz eşleştirme',
    'settings.feature.matching.description':
        'Referanstaki tüm yüzleri arama alanındaki tüm yüzlerle karşılaştırır.',
    'settings.feature.landmarks.label': '68 yüz işaret noktası',
    'settings.feature.landmarks.description': 'Çene, kaş, göz, burun ve ağız konturlarını çıkarır.',
    'settings.feature.expressions.label': 'İfade analizi',
    'settings.feature.expressions.description':
        'Nötr, mutlu, üzgün, kızgın, korkmuş, tiksinmiş ve şaşkın.',
    'settings.feature.ageAndGender.label': 'Yaş ve cinsiyet',
    'settings.feature.ageAndGender.description':
        'Tahmini yaş ve modelin ikili cinsiyet sınıflandırmasını gösterir.',
    'settings.align': 'Yüzleri hizala',
    'settings.alignDescription':
        'İfade, yaş ve cinsiyet analizini daha kararlı kılar. Eşleştirmede zorunludur.',
    'settings.distanceThreshold': 'Eşleşme uzaklığı eşiği',
    'settings.maxDimension': 'En büyük analiz boyutu',
    'settings.fast': 'hızlı',
    'settings.recommended': 'önerilen',
    'settings.originalSize': 'Özgün boyut',
    'settings.dimensionHelp':
        'Büyük medya analizden önce orantılı küçültülür; sonuçlar özgün koordinatlara geri çevrilir.',
    'settings.detectorInactive': 'Bu ayarlar, bu dedektör seçiliyken uygulanır.',
    'settings.minimumConfidence': 'Minimum güven',
    'settings.maximumResults': 'En fazla sonuç',
    'settings.inputSize': 'Giriş boyutu',
    'settings.scoreThreshold': 'Skor eşiği',
    'settings.minimumFaceSize': 'Minimum yüz boyutu',
    'settings.scaleFactor': 'Ölçek katsayısı',
    'settings.maximumScales': 'En fazla ölçek',
    'settings.stageThreshold': 'Aşama %{stage} skor eşiği',
    'settings.customScaleSteps': 'Özel ölçek adımları',
    'settings.commaSeparatedSteps': 'Virgülle ayrılmış adımlar',
    'settings.overlay.reference': 'Referans katmanları',
    'settings.overlay.haystack': 'Arama alanı katmanları',
    'settings.drawingHelp':
        'Çizim değişiklikleri analizi yeniden çalıştırmadan mevcut sonuca uygulanır.',
    'settings.unknownFaces': 'Tanınmayan yüzler',
    'settings.unknownFacesDescription':
        'Hiçbir referansla eşleşmeyen yüzleri çizer. Yüz eşleştirme gerektirir.',
    'settings.boxes': 'Sınır kutuları',
    'settings.scores': 'Tespit skorları',
    'settings.labels': 'Etiketler ve analiz değerleri',
    'settings.landmarkLines': 'Yüz işareti çizgileri',
    'settings.landmarkPoints': 'Yüz işareti noktaları',
    'settings.color.box': 'Kutu',
    'settings.color.match': 'Eşleşme',
    'settings.color.unknown': 'Bilinmiyor',
    'settings.color.landmarkLine': 'İşaret çizgisi',
    'settings.color.landmarkPoint': 'İşaret noktası',
    'settings.lineWidth': 'Çizgi kalınlığı',
    'settings.pointSize': 'Nokta boyutu',
    'settings.fontSize': 'Etiket yazı boyutu',
    'settings.expressionProbability': 'Minimum ifade olasılığı',
    'settings.modelSource': 'Model kaynağı',
    'settings.modelRootUrl': 'Model kök URL’si',
    'settings.modelSourceHelp': 'Manifest ve shard dosyaları aynı klasörde bulunmalıdır.',
    'settings.modelReady': 'Hazır',
    'settings.modelUnavailable': 'Resmi ağırlık yok',
    'settings.runRunning': 'Analiz çalışıyor…',
    'settings.run': 'Analizi başlat',
    'model.tinyFaceDetector': 'Tiny Face Detector',
    'model.ssdMobilenetv1': 'SSD MobileNet V1',
    'model.mtcnn': 'MTCNN',
    'model.tinyYolov2': 'Tiny YOLOv2',
    'model.faceLandmark68Net': '68 nokta yüz işaretleri',
    'model.faceLandmark68TinyNet': 'Tiny 68 nokta yüz işaretleri',
    'model.faceRecognitionNet': 'Yüz tanıma ağı',
    'model.faceExpressionNet': 'Yüz ifadesi ağı',
    'model.ageGenderNet': 'Yaş ve cinsiyet ağı',
    'results.eyebrow': 'ANALİZ TAMAMLANDI',
    'results.title': 'Bulunan yüzler',
    'results.matches': '%{count} eşleşme',
    'results.targets': '%{count} arama alanı yüzü',
    'results.seconds': '%{seconds} sn',
    'results.references': 'Referanslar',
    'results.reference': 'Referans',
    'results.referenceNumber': 'Şahıs %{number}',
    'results.referenceLabel': 'Referans %{number} etiketi',
    'results.targetFaces': 'Arama alanı yüzleri',
    'results.faceNumber': 'Yüz %{number}',
    'results.noMatch': 'Tanınmayan',
    'results.noFaces':
        'Arama alanında yüz bulunamadı. Tespit modelini veya eşik ayarlarını değiştirmeyi deneyin.',
    'results.metric.detection': 'tespit',
    'results.metric.expression': 'ifade',
    'results.metric.age': 'yaş',
    'results.metric.gender': 'cinsiyet',
    'results.metric.distance': 'uzaklık',
    'results.gender.female': 'Kadın',
    'results.gender.male': 'Erkek',
    'results.expression.neutral': 'Nötr',
    'results.expression.happy': 'Mutlu',
    'results.expression.sad': 'Üzgün',
    'results.expression.angry': 'Kızgın',
    'results.expression.fearful': 'Korkmuş',
    'results.expression.disgusted': 'Tiksinmiş',
    'results.expression.surprised': 'Şaşkın',
    'webmcp.title': 'Yüz analizini hazırla',
    'webmcp.description':
        'Görünür Face Lab arayüzünde yüz tespit modelini, eşleştirme seçimini ve medya URL’lerini analiz için hazırlar. Analizi çalıştırmaz.',
    'webmcp.error.kind': 'Medya türü image veya video olmalıdır.',
    'webmcp.error.haystack': 'haystackUrl zorunlu bir metin alanıdır.',
    'webmcp.error.detector': 'Geçersiz yüz tespit modeli.',
    'webmcp.error.reference': 'Eşleştirme etkinse referenceUrl zorunludur.',
};
